import React from 'react';
import { useGlobalScrollAnimation } from '../hooks/useGlobalScrollAnimation';
import './About.css';

const About = () => {
  const { animatedSections } = useGlobalScrollAnimation();
  const isAboutAnimated = animatedSections.has('about');

  return (
    <section id="about" className="section about">
      <div className="container">
        <h2 className="section-title progressive-element">קצת עליי</h2>

        <div className="about-content">
          {/* Full-bleed image section */}
          <div className="image-container full-bleed progressive-element">
            <img
              src="/images/hero.jpg"
              alt="Professional driving instructor portrait"
              className="section-image"
            />
          </div>

          {/* Text content overlaying image */}
          <div className={`text-content overlay-card progressive-element ${isAboutAnimated ? 'loaded' : ''}`}>
            <div className="intro-text">
            אני מאמין שכל אחד יכול ללמוד נהיגה ולכן אני מתאים את עצמי לכל תלמיד בצורה שונה
            </div>

            <div className="about-features">
              <div className="about-feature">
                <h4>סבלנות</h4>
                <p>לכל תלמיד יש את הקצב שלו ללמידה ואני כאן כדי להתאים את קצב הלמידה לכל אחד ואחת.</p>
              </div>

              <div className="about-feature">
                <h4>מקצועיות</h4>
                <p>הסבר מפורט ומעמיק על כל נושא ומשימה על מנת שתצליחו לעשות את הטוב ביותר.</p>
              </div>

              <div className="about-feature">
                <h4>ביטחון</h4>
                <p>אני שולט בכל מערכות הרכב מצד ימין וכל הנעשה ברכב תחת אחריותי בלבד לכם נשאר רק ללמוד ולהינות.</p>
              </div>

              <div className="about-feature">
                <h4>התמודדות עם חרדות</h4>
                <p>ברשותי כלים פרקטיים להתמודדות עם חרדות ואני אלווה אתכם לנצח כל מכשול.</p>
              </div>
            </div>

            <div className="about-goal">
              <h4>המטרה שלי אחת -</h4>
              <p>שלכם יהיה רשיון בדרך הבטוחה ביותר והמהירה ביותר</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
